import { motion } from "framer-motion";

export function Panel({ title, subtitle, testid, className = "", children, right }) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      data-testid={testid}
      className={`bg-white border border-[#DCD9D0] flex flex-col min-w-0 ${className}`}
    >
      <div className="px-5 py-3.5 border-b border-[#DCD9D0] flex items-center gap-3">
        <div className="min-w-0">
          <div className="font-mono-eo text-[10px] uppercase tracking-[0.2em] text-[#5C5C54]">// {title}</div>
          {subtitle && <div className="text-[12px] text-[#8A8A80] mt-0.5">{subtitle}</div>}
        </div>
        <div className="flex-1" />
        {right}
      </div>
      <div className="p-5 flex-1 min-h-0">{children}</div>
    </motion.section>
  );
}

export const Empty = ({ text }) => (
  <div className="h-full min-h-[120px] flex items-center justify-center text-[13px] text-[#8A8A80]">{text}</div>
);
